import { pxToRem } from '@back-office/core';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, { ChangeEvent, FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getDatetimeText } from '../../utils';
import GcpTypography from '../gcp-typography';

const useStyles = makeStyles(
  (theme) => ({
    navigation: {
      position: 'absolute',
      bottom: 0,
    },
    reserved: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    root: {
      alignItems: 'center',
      '& > .MuiBottomNavigationAction-root': {
        color: theme.palette.common.hitGray,
        width: pxToRem(14),
        height: pxToRem(14),
      },
      '& > .MuiBottomNavigationAction-root.Mui-selected': {
        color: theme.palette.primary.main,
      },
    },
    menu: {
      display: 'flex',
      justifyContent: 'center',
    },
    [theme.breakpoints.down('sm')]: {
      navigation: {
        position: 'unset',
        paddingTop: theme.spacing(5),
        bottom: 0,
      },
    },
  }),
  { name: 'GcpBottomNavigation' }
);

export const GcpBottomNavigation: FC = () => {
  const classes = useStyles();
  const [value, setValue] = useState('');
  const { t } = useTranslation();

  const date = getDatetimeText(new Date(), 'year');

  const handleChange = (
    event: ChangeEvent<Record<string, unknown>>,
    newValue: string
  ): void => {
    setValue(newValue);
  };

  return (
    <Container className={classes.navigation}>
      <Grid container>
        <Grid item className={classes.reserved} md={6} xs={12}>
          <GcpTypography paint="hitGray" variant="body2">
            {t('invitations.all_rights_reserved', { date })}
          </GcpTypography>
        </Grid>
        <Grid item className={classes.menu} md={6} xs={12}>
          <BottomNavigation
            showLabels
            className={classes.root}
            value={value}
            onChange={handleChange}
          >
            <BottomNavigationAction
              label={t('invitations.about')}
              value="about"
            />
            <BottomNavigationAction
              label={t('invitations.help')}
              value="help"
            />
            <BottomNavigationAction
              label={t('invitations.terms')}
              value="terms"
            />
            <BottomNavigationAction
              label={t('invitations.privacy')}
              value="privacy"
            />
          </BottomNavigation>
        </Grid>
      </Grid>
    </Container>
  );
};

export default GcpBottomNavigation;
